import React from "react";
import styled from "styled-components";
import Skeleton from "common/NewLook/Skeleton.tsx";
import {
  newLookCardSurface,
  newLookWell,
} from "features/bots/NewLook/newLookStyles";

/**
 * New look: a public bot card's placeholder, zone for zone at the real
 * card's heights (who, total profit over its chart, the figures' well, the
 * chips), shown while the public bots load for the first time.
 */
const NewLookPublicBotCardSkeleton = () => (
  <Card aria-hidden={true}>
    <Row style={{ height: 40 }}>
      <Skeleton width={40} height={40} radius={20} />
      <Column>
        <Skeleton width="56%" height={12} />
        <Skeleton width="38%" height={10} />
      </Column>
      <Skeleton width={84} height={30} radius={8} />
    </Row>
    <Result>
      <Skeleton width={120} height={20} />
      <Chart>
        <Skeleton width="100%" height={64} radius={8} />
      </Chart>
    </Result>
    <Figures>
      {[0, 1, 2].map((index) => (
        <Column key={index}>
          <Skeleton width="70%" height={10} />
          <Skeleton width="54%" height={14} />
        </Column>
      ))}
    </Figures>
    <Row style={{ height: 22, marginTop: "auto" }}>
      <Skeleton width={44} height={22} />
      <Skeleton width={80} height={22} />
      <Skeleton width={96} height={10} style={{ marginLeft: "auto" }} />
    </Row>
  </Card>
);

export default React.memo(NewLookPublicBotCardSkeleton);

const Card = styled.div`
  ${newLookCardSurface};
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 20px;
  @media (max-width: 600px) {
    gap: 12px;
  }
`;
const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
`;
const Column = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
`;
const Result = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  @media (max-width: 600px) {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
  }
`;
const Chart = styled.div`
  @media (max-width: 600px) {
    flex: 0 1 160px;
    > span {
      height: 36px !important;
    }
  }
`;
const Figures = styled.div`
  ${newLookWell};
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 24px;
  padding: 14px 12px;
`;
